import Vue from 'vue'

const state = {
    parking: {},
    parking_transaction: {},
    transactions_user: {},
    users: {},
    booking: {},
    booking_request: {},
    authorization: {},
    feedback: {},
    coupon: {},
    coupon_type: {},
    owner: {},
    email_case: {}
}
const getters = {}
const actions = {}
const mutations = {
    set_cols (state, data) {
        let item = {
            name: 'Выбрать все',
            value: true
        }
        Vue.set(state[data.page], 'all', item);
        for (let key in data.cols) {
            let item = {
                name: data.cols[key].name,
                value: true
            }
            Vue.set(state[data.page], key, item);
        }
    },
    update_cols (state, data) {
        if (data.fieldName == 'all') {
            for (let key in state[data.page]) {
                state[data.page][key].value = data.value
            }
        } else {
            state[data.page][data.fieldName].value = data.value
            let count = 0
            for (let key in state[data.page]) {
                if (state[data.page][key].value) count++
            }
            let max = Object.keys(state[data.page]).length
            if (count == max - 1) { // "выбрать все"
                state[data.page]['all'].value = data.value
            }
        }
    },
    update_all (state, data) {
        state[data.page] = data.settings
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}